<template lang="pug">
  utility-action-state(
    v-if="!isUserBlocked"
    :action="goToAdWatch")
    template(#default="{ loading, trigger }")
      v-btn(
        @click="$createOnClick({ support: trigger })"
        :loading="loading"
        :disabled="loading"
        rounded
        style="width: 96px"
        color="primary") Soutenir
</template>

<script>
import { mdiHandHeart } from '@mdi/js'
import { injectRouteState } from '@iez/core'
import UtilityActionState from '@iez/components/utility/action-state/'
import doSupport from '@/shared/do-support/'
import isUserBlocked from '@/shared/is-user-blocked/'

export default {
  components: {
    UtilityActionState
  },

  setup () {
    const routeState = injectRouteState()

    const goToAdWatch = async () => {
      await doSupport({
        supportedAssociationId: routeState.user?.association?.id
      })
    }

    return {
      mdiHandHeart,
      goToAdWatch,
      routeState,
      isUserBlocked
    }
  }
}
</script>
